<template>
    <CardDropdownSm :item="socialData">
        <template #icon>
            <component :is="socialData.icon" class="flex-shrink-0 h-5 ct-fg-4" />
        </template>
    </CardDropdownSm>
</template>

<script>
import { markRaw } from "vue";
import { PencilSquareIcon, CopyDocumentIcon, TrashBinIcon } from "@easy/ui/icons";
import { CardDropdownSm } from "@easy/ui/cards";
import { FormToggleSm } from "@easy/ui/forms";

export default {
    props: {
        social: {
            type: Object,
            required: true,
        },
    },
    emits: ["edit"],
    components: {
        PencilSquareIcon,
        CopyDocumentIcon,
        CardDropdownSm,
        FormToggleSm,
        TrashBinIcon,
    },
    computed: {
        socialData() {
            return {
                title: this.social.title,
                icon: this.social.icon,
                url: this.social.url,
                actions: [
                    {
                        label: this.$t("shared.edit"),
                        icon: markRaw(PencilSquareIcon),
                        handler: () => {
                            this.$emit("edit");
                        },
                    },
                ],
            };
        },
    },
};
</script>
